import { Drawer } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/Button/Button';
import { CloseIconButton } from 'components/Button/CloseButton/CloseIconButton';
import { DropDownMenu } from 'components/DropDownMenu/DropDownMenu';
import { PatientDetails } from 'components/PatientDetails/PatientDetails';
import { Person } from 'redux/person/personTypes';
import style from './PatientInfoDrawer.scss';

type ViewPersonProps = {
  person: Nullable<Person>;
  visible: boolean;
  onClose: () => void;
  onDeletePatientClick?: (personId: string) => void;
  withButtons?: boolean;
  hasPatientCreatePermission?: boolean;
};

export const PatientInfoDrawer: React.FC<ViewPersonProps> = ({ person = null, visible, onClose, onDeletePatientClick, withButtons = false, hasPatientCreatePermission = true }) => {
  const navigate = useNavigate();
  const onPressOpenDashboard = useCallback(() => {
    navigate(`/patients/${person?.id}`);
  }, [person]);

  const onEditPatientClick = useCallback(() => {
    navigate(`/patients/${person?.id}/editPatient`);
  }, [person]);

  if (!person) {
    return null;
  }

  const menuItems = [
    ...(hasPatientCreatePermission ? [{
      text: 'Edit',
      onClick: onEditPatientClick
    }] : []),
    ...(hasPatientCreatePermission ? [{
      text: 'Deactivate',
      textClassName: style.redText,
      onClick: () => onDeletePatientClick?.(person.id)
    }] : [])
  ];

  return (
    <Drawer anchor="right" open={visible} onClose={onClose}>
      <div className={style.drawerContainer}>
        <div className={style.drawerHeader}>
          <CloseIconButton onClick={onClose} />
        </div>
        <PatientDetails person={person}>
          {withButtons ? (
            <div className={style.buttonsArea}>
              <DropDownMenu
                menuText="Actions"
                menuItems={menuItems}
                disabled={menuItems.length === 0}
              />
              <Button className={style.navigationButton} variant="contained" onClick={onPressOpenDashboard}>
                Open dashboard
              </Button>
            </div>
          ) : null}
        </PatientDetails>
      </div>
    </Drawer>
  );
};
